import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { RoleDTO } from 'src/app/models/RoleDTO.model';
import { UserManagementDTO } from 'src/app/models/UserManagementDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { RoleService } from 'src/app/services/role.service';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { emailValidator } from 'src/app/validators/email.validator';

import { CommonModule } from '@angular/common';
import { FormatPhoneUsDirective } from '../../../directives/format-phone-us.directive';
import { FormatEmailDirective } from '../../../directives/format-email.directive';
@Component({
    selector: 'app-create-user',
    templateUrl: './create-user.component.html',
    styleUrl: './create-user.component.css',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormatPhoneUsDirective,
        FormatEmailDirective
    ]
})
export class CreateUserComponent {
  title: string = 'Create Management User';
  fieldsCompleted: boolean = false;

  form = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator()]), 
  });

  get emailModel() {
    return this.form.get('email');
  }

  information: string = 'Information';
  userName: string = '';
  address: string = '';
  city: string = '';
  zipCode?: number = undefined;
  stateSelected: string = '';
  roleSelected: number = 0;
  states: MasterDataDTO[] = [];
  roles: RoleDTO[] = [];
  contactNumber?: string = undefined;
  email: string = '';
  masterdataRequestDTO: MasterdataRequestDTO = {
    idMaster: 1,
  };
  validMail: boolean = false;

  alert: Alert = {} as Alert;
  user: UserManagementDTO = {} as UserManagementDTO;
  isActive: boolean = false;

  constructor(
    private customerService: CustomerService,
    private roleService: RoleService,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.UserManagement);

    this.customerService.getMastersById(this.masterdataRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetAllStatesSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
      }
    );

    this.roleService.getRoles().subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.HandleGetRoles(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
      }
    );
  }

  HandleGetRoles(roles: RoleDTO[]) {
    //console.log(roles);
    this.roles = roles;
  }

  handleGetAllStatesSuccess(states: MasterDataDTO[]) {
    this.states = states;
  }

  clearFields() {
    this.userName = '';
    this.address = '';
    this.city = '';
    this.zipCode = undefined;
    this.stateSelected = '';
    this.contactNumber = undefined;
    this.email = '';
    this.roleSelected = 0;
  }

  createUser() {
    this.user.userNames = this.userName;
    this.user.userAddress = this.address;
    this.user.userCity = this.city;
    this.user.userState = this.stateSelected;
    this.user.zipCode = this.zipCode;
    this.user.userPhone = this.contactNumber;
    const emailValue = this.form.get('email')?.value ?? '';
    this.user.userMail = emailValue;
    this.user.roleId = this.roleSelected;
    this.user.userStatus = this.isActive ? 1 : 0;

    this.customerService.saveUserManagement(this.user).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleSaveSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
        this.clearFields();
      }
    );
  }

  checkFields() {
    if (
      this.userName &&
      this.contactNumber &&
      this.form.get('email')?.value &&
      this.roleSelected !== 0
    ) {
      this.fieldsCompleted = true;
    } else {
      this.fieldsCompleted = false;
    }
  }

  goBack() {
    window.location.href = '/user-management';
  }

  handleSaveError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
    this.clearFields();
  }

  async handleSaveSuccess(user: UserManagementDTO) {
    //console.log(user.userId);
    if (user.userId === 0) {
      this.alert = {
        alertMessage: 'This user already exists',
        alertType: 'alert alert-warning',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };

      this.alertService.updateAlertState(this.alert);
    } else {
      this.alert = {
        alertMessage: 'User saved successfully',
        alertType: 'alert alert-success',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };
      localStorage.setItem('AlertObject', JSON.stringify(this.alert));
      this.alertService.updateAlertState(this.alert);
      this.router.navigate(['/user-management']);
    }
  }

  checkEmailValidity() {
    const isValid = this.emailModel?.valid;
    if (isValid) {
      this.validMail = true;
    } else {
      this.validMail = false;
    }
  }
}
